import React, {useEffect, useState} from 'react';
import {makeStyles} from '@mui/styles';
import {Card, Grid} from '@mui/material';
import {SECURITY_ROLES} from '../../../constants/SECURITY_ROLES';
import {Redirect} from 'react-router-dom';

import {DocumentMetrics, DocumentsHistory, LatestDocuments, TopDocumentsViewedMetrics, StagedDocumentMetrics} from '../components/';
import {useDispatch, useSelector} from 'react-redux';
import {CompanyMetrics, PendingDocuments, UsersMetrics} from './components/';
import CompanyUserRoleMetrics from './components/CompanyUserRoleMetrics';
import {dashboardService} from '../../../store/services';
import LoadingSpinner from "../../../components/Spinner/loading.spinner";
// import SignedDocumentMetrics from "../components/UsersMetrics/SignedDocumentMetrics";
import ESignDocumentMetrics from "../components/ESignDocumentMetrics";
import buildGridItem from '../../../common/buildGridItems';

const useStyles = makeStyles(theme => ({
  root: {
    //marginBottom: theme.spacing(4)
  }
}));

const CompanyAdminDashboard = () => {
  const classes = useStyles();
  const {user, manageESign, eSignAccessToken} = useSelector(state => {
    return {
      user: state.authentication.user,
      eSignAccessToken: state.authentication.user.eSignAccessToken,
      manageESign: state.authentication.user.manageESign
    }});
  const [metrics, setMetrics] = useState(null);
  const dispatch = useDispatch();

  const widgets=
    [
      {
        id: 0,
        name: 'User Role',
        loadingMessage: 'Role Metrics',
        columns: 4,
        component: (<CompanyUserRoleMetrics metrics={metrics}/>),
      },
      {
        id: 1,
        name: 'Multimedia',
        loadingMessage: 'Multimedia Metrics',
        columns: 4,
        component: (<DocumentMetrics metrics={metrics} view={SECURITY_ROLES.COMPANY_ADMIN}/>),
      },
      {
        id: 2,
        name: 'Staging Multimedia',
        loadingMessage: 'Staging Multimedia Metrics',
        columns: 4,
        component: (<StagedDocumentMetrics metrics={metrics}/>),
      }
    ];

  if (user.manageESign){
    widgets.push(
      {
        id: widgets.length,
          name: 'ESign',
        loadingMessage: 'Signed Documents',
        columns: 4,
        component: (<ESignDocumentMetrics metrics={metrics}/>),
      }
    )
  }

  const calculateGrid = (columns) => {
    return ((widgets.length % columns) === 0) ? 3 : 4
  }


  useEffect(() => {
    let isSubscribed = true;
    if (user) {
      dashboardService.getCompanyAdminDashboardMetrics(user.companyId)
        .then(metrics => isSubscribed ? setMetrics(metrics.data) : null);
    }
    return () => (isSubscribed = false);
  }, [user, dispatch]);

  return (
    <React.Fragment>
      {user && (user.role) && (user.role === SECURITY_ROLES.COMPANY_ADMIN) ?
        (
          <div className={classes.root}>
            <Grid
              container
              spacing={3}
            >
              {buildGridItem(metrics, (<PendingDocuments metrics={metrics}/>), 'Pending Multimedia', {xl: 4,lg: 4,md: 4,sm: 4, xs: 12})}
              {buildGridItem(metrics, (<CompanyMetrics metrics={metrics}/>), 'Company Metrics', {xl: 4,lg: 4,md: 4,sm: 4, xs: 12})}
              {buildGridItem(metrics, (<UsersMetrics userData={metrics}/>), 'User Metrics', {xl: 4,lg: 4,md: 4,sm: 4, xs: 12})}
              {
                widgets.map((widget) => (
                  buildGridItem(metrics, widget.component, widget.name, {xl: calculateGrid(widget.columns),lg: 6,md: 6,sm: 12, xs: 12})
                ))
              }
              {buildGridItem(metrics, (<TopDocumentsViewedMetrics metrics={metrics}/>), 'Top Multimedia', {xl: 6,lg: 6,md: 12,sm: 12, xs: 12})}
              {buildGridItem(metrics, (<DocumentsHistory metrics={metrics}/>), 'Multimedia History', {xl: 6,lg: 6,md: 12,sm: 12, xs: 12})}
            </Grid>
          </div>)
        :
        (<Redirect to="/login"/>)
      }
    </React.Fragment>
  );
};

export default CompanyAdminDashboard;
